import { NullState } from '@mi-front/ui';
import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useYoutubeNativeStations } from '@app/core/stations/hooks/useYoutubeNativeStations';
import { youtubeBroadcastsListMessages } from './youtube-broadcasts-list.messages';
import { youtubeBroadcastsListRouteGenerator } from './youtube-broadcasts-list-routes';

/**
 * Renders children only when the active station is YouTube Native; otherwise redirects or shows empty state.
 */
export function IfYoutubeNativeStation({ children }: PropsWithChildren) {
  const station = useActiveStation();
  const youtubeNativeStations = useYoutubeNativeStations();

  if (!station.youtubeNative) {
    const fallback = youtubeNativeStations[0];

    if (fallback) {
      return <Redirect to={youtubeBroadcastsListRouteGenerator.list(fallback.slug)} />;
    }

    return (
      <Box mt={4}>
        <NullState className="text-left">
          <FormattedMessage {...youtubeBroadcastsListMessages.noYoutubeNativeStations} />
        </NullState>
      </Box>
    );
  }

  return <>{children}</>;
}
